// ============================================================================
// 桌面版免登录恢复 —— 必须在 import store / router 之前执行
// ============================================================================
// 为什么独立成一个模块、且必须在 src/main.js 第一行 import：
//   前端 store/index.js 的 hydrate（读 localStorage.token + drying_auth_snapshot_v1）
//   和路由守卫的首次判断，都在 ES module import 时同步发生。而 webbox 主进程的
//   did-finish-load 注入是异步的，赶不上这首次判断 —— 于是 token 一旦随 localStorage
//   丢失（异常退出/存储损坏/安全软件清理），用户就会被路由守卫踢回登录页，即便凭据
//   文件里有备份也用不上。
//   这里通过 preload 暴露的同步 peek()，在 store 加载前把 token / snapshot 写回 localStorage。
//
// 非 webbox 环境（普通浏览器访问）：window.desktop 不存在，整段无副作用。
// ============================================================================

try {
  if (typeof window !== 'undefined' &&
      window.desktop && window.desktop.credentials &&
      !localStorage.getItem('token')) {
    const saved = window.desktop.credentials.peek() // 同步读取，关键
    if (saved && saved.token) {
      localStorage.setItem('token', saved.token)
      if (saved.snapshot) {
        localStorage.setItem('drying_auth_snapshot_v1', saved.snapshot)
      }
      // eslint-disable-next-line no-console
      console.info('[desktopAuthBoot] 已从桌面凭据文件恢复登录态')
    }
  }
} catch (e) {
  // 恢复失败不影响启动，最坏情况是回到登录页手动登录一次
  // eslint-disable-next-line no-console
  console.warn('[desktopAuthBoot] 恢复登录态失败:', e && e.message)
}
